var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { useTreeMenuData } from "@/components/menu/items/use-tree-menu-hook";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { Box, Typography, styled } from "@mui/material";
import { BooleanInput, SimpleForm, TextInput, NumberInput, SelectInput, ReferenceInput, Create, useRedirect, Toolbar, SaveButton, } from "react-admin";
import { JsonInput } from "react-admin-json-view";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NewResourceContext } from "@/providers/NewResourceProvider";
import { ICountingAlgorithm } from "@sequentech/ui-core";
import { CandidatesOrder } from "@sequentech/ui-core";
import { addDefaultTranslationsToElement } from "@/services/i18n";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
var Hidden = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: none;\n"], ["\n    display: none;\n"])));
export var CreateContest = function () {
    var t = useTranslation().t;
    var tenantId = useTenantStore()[0];
    var searchParams = useSearchParams()[0];
    var redirect = useRedirect();
    var electionEventId = searchParams.get("electionEventId");
    var electionId = searchParams.get("electionId");
    var refetch = useTreeMenuData(false).refetch;
    var setLastCreatedResource = useContext(NewResourceContext).setLastCreatedResource;
    var countingAlgorithmChoices = function () {
        return Object.values(ICountingAlgorithm).map(function (value) { return ({
            id: value,
            name: t("contestScreen.options.".concat(value.toLowerCase())),
        }); });
    };
    var setContestIdFlag = useElectionEventTallyStore().setContestIdFlag;
    var transform = function (data) {
        var i18n = addDefaultTranslationsToElement(data);
        var presentation = __assign(__assign({}, data.presentation), { i18n: i18n });
        return __assign(__assign({}, data), { presentation: presentation });
    };
    return (_jsx(Create, { mutationOptions: {
            onSuccess: function (data) {
                refetch();
                setLastCreatedResource({ id: data.id, type: "sequent_backend_contest" });
                setContestIdFlag(data.id);
                redirect("/sequent_backend_contest/".concat(data.id));
            },
        }, transform: transform, children: _jsxs(SimpleForm, { toolbar: _jsx(Toolbar, { children: _jsx(SaveButton, { className: "contest-save-button" }) }), children: [_jsx(Typography, { variant: "h4", children: t("common.resources.contest") }), _jsx(Typography, { variant: "body2", children: t("createResource.contest") }), _jsx(TextInput, { source: "name" }), _jsx(TextInput, { source: "description" }), _jsx(TextInput, { source: "external_id", label: String(t("contestScreen.edit.externalId")) }), _jsxs(Hidden, { children: [_jsx(BooleanInput, { source: "is_acclaimed" }), _jsx(BooleanInput, { source: "presentation.allow_writeins", defaultValue: true }), _jsx(BooleanInput, { source: "is_active", defaultValue: true }), _jsx(NumberInput, { source: "min_votes", defaultValue: "0" }), _jsx(NumberInput, { source: "max_votes", defaultValue: "1" }), _jsx(NumberInput, { source: "winning_candidates_num", defaultValue: 1 }), _jsx(SelectInput, { source: "counting_algorithm", defaultValue: ICountingAlgorithm.PLURALITY_AT_LARGE, choices: countingAlgorithmChoices() }), _jsx(SelectInput, { source: "presentation.candidates_order", defaultValue: CandidatesOrder.ALPHABETICAL, choices: [
                                {
                                    id: CandidatesOrder.ALPHABETICAL,
                                    name: CandidatesOrder.ALPHABETICAL,
                                },
                            ] }), _jsx(BooleanInput, { source: "is_encrypted", defaultValue: true }), _jsx(TextInput, { source: "presentation.candidates_order" }), _jsx(ReferenceInput, { source: "tenant_id", reference: "sequent_backend_tenant", children: _jsx(SelectInput, { optionText: "slug", defaultValue: tenantId }) }), _jsx(ReferenceInput, { source: "election_event_id", reference: "sequent_backend_election_event", children: _jsx(SelectInput, { optionText: "name", defaultValue: electionEventId }) }), _jsx(ReferenceInput, { source: "election_id", reference: "sequent_backend_election", children: _jsx(SelectInput, { optionText: "name", defaultValue: electionId }) }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                                name: null,
                                collapsed: true,
                                enableClipboard: true,
                                displayDataTypes: false,
                            } }), _jsx(JsonInput, { source: "labels", jsonString: false, reactJsonOptions: {
                                name: null,
                                collapsed: true,
                                enableClipboard: true,
                                displayDataTypes: false,
                            } }), _jsx(JsonInput, { source: "annotations", jsonString: false, reactJsonOptions: {
                                name: null,
                                collapsed: true,
                                enableClipboard: true,
                                displayDataTypes: false,
                            } }), _jsx(JsonInput, { source: "presentation", jsonString: false, reactJsonOptions: {
                                name: null,
                                collapsed: true,
                                enableClipboard: true,
                                displayDataTypes: false,
                            } }), _jsx(JsonInput, { source: "tally_configuration", jsonString: false, reactJsonOptions: {
                                name: null,
                                collapsed: true,
                                enableClipboard: true,
                                displayDataTypes: false,
                            } }), _jsx(JsonInput, { source: "conditions", jsonString: false, reactJsonOptions: {
                                name: null,
                                collapsed: true,
                                enableClipboard: true,
                                displayDataTypes: false,
                            } })] })] }) }));
};
var templateObject_1;
